import React, { useEffect, useRef } from "react";
import { Popover } from "react-tiny-popover";
import { twMerge } from "tailwind-merge";
type Position = "bottom" | "left" | "right" | "top";

const UIPopoverComponent = Popover as any;

function UIPopover({
  children,
  trigger,
  positions,
  align,
  withChevron,
  containerClassName,
  popoverButtonClassName = "",
  disabled,
  shouldCloseOnScroll = true,
  onClick,
  onClose,
  transform,
  transformMode,
}: {
  children: (close: () => void, position?: string) => any;
  trigger: any;
  positions?: Position[];
  withChevron?: boolean;
  containerClassName?: string;
  popoverButtonClassName?: string;
  disabled?: boolean;
  align?: "start" | "center" | "end";
  shouldCloseOnScroll?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClose?: () => void;
  transform?: { [key: string]: number };
  transformMode?: "absolute" | "relative";
}) {
  const clickMeButtonRef = useRef<any>();
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);

  useEffect(() => {
    // on scroll, close the popover
    const handleScroll = () => {
      if (shouldCloseOnScroll) {
        onClose?.();
        setIsPopoverOpen(false);
      }
    };
    document.addEventListener("scroll", handleScroll, true);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [shouldCloseOnScroll]);

  return (
    <UIPopoverComponent
      isOpen={isPopoverOpen}
      positions={positions || ["bottom", "top", "left", "right"]}
      align={align}
      clickOutsideCapture={true}
      onClickOutside={() => {
        onClose?.();
        setIsPopoverOpen(false);
      }}
      ref={clickMeButtonRef}
      content={({ position }) =>
        children(() => {
          setIsPopoverOpen(!isPopoverOpen);
        }, position)
      }
      containerClassName={containerClassName}
      transform={transform}
      transformMode={transformMode}
      containerStyle={{
        zIndex: "10",
      }}
    >
      <button
        type="button"
        className={twMerge(
          `flex flex-col ${isPopoverOpen ? "[&>div>div]:bg-primary" : ""}`,
          popoverButtonClassName
        )}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
          setIsPopoverOpen(!isPopoverOpen);
        }}
        disabled={disabled}
      >
        {withChevron ? trigger(isPopoverOpen) : trigger}
      </button>
    </UIPopoverComponent>
  );
}

export default UIPopover;
